// 현재 탭 + 페이지 타이틀 — 프로토타입의 switchTab/PAGE_TITLES를 zustand 스토어로 변환
import { create } from 'zustand';

export type TabId = 'overview' | 'test' | 'logs' | 'quarantine' | 'policies' | 'engines' | 'settings' | 'api' | 'activity' | 'manual' | 'blacklist';

export const PAGE_TITLES: Record<TabId, { main: string; em: string }> = {
  overview: { main: '개요', em: 'System Overview' },
  test: { main: '파일검사', em: '실시간 검사' },
  logs: { main: '검사 로그', em: '전체 이력' },
  quarantine: { main: '격리소', em: '의심 파일 관리' },
  policies: { main: '정책 관리', em: '프로젝트별 규칙' },
  engines: { main: '엔진 상태', em: '운영 모니터링' },
  settings: { main: '시스템 설정', em: 'System Settings' },
  api: { main: 'API 문서', em: 'REST v1' },
  activity: { main: '활동 로그', em: '실시간 이벤트' },
  manual: { main: '사용설명서', em: '이용 안내' },
  blacklist: { main: '해시 블랙리스트', em: 'SHA-256 차단 목록' },
};

interface TabState {
  tab: TabId;
  setTab: (t: TabId) => void;
}

export const useTab = create<TabState>((set) => ({
  tab: 'overview',
  setTab: (t) => set({ tab: t }),
}));
